"use strict";

var _slicedToArray = require("/Users/arpita/development/arpitasingh5.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/arpita/development/arpitasingh5.github.io/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arpita/development/arpitasingh5.github.io/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mover = void 0;

var Utils_1 = require("../../Utils");

var Enums_1 = require("../../Enums");

var Mover = /*#__PURE__*/function () {
  function Mover(container, particle) {
    _classCallCheck(this, Mover);

    this.container = container;
    this.particle = particle;
  }

  _createClass(Mover, [{
    key: "move",
    value: function move(delta) {
      var particle = this.particle;
      particle.bubble.inRange = false;
      particle.links = [];

      var _iterator = _createForOfIteratorHelper(this.container.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              plugin = _step$value[1];

          if (particle.destroyed) {
            break;
          }

          if (plugin.particleUpdate) {
            plugin.particleUpdate(particle, delta);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (particle.destroyed) {
        return;
      }

      this.moveParticle(delta);
      this.moveParallax();
    }
  }, {
    key: "moveParticle",
    value: function moveParticle(delta) {
      var _a;

      var particle = this.particle;
      var particlesOptions = particle.particlesOptions;

      if (!particlesOptions.move.enable) {
        return;
      }

      var container = this.container;
      var slowFactor = this.getProximitySpeedFactor();
      var baseSpeed = (_a = particle.moveSpeed) !== null && _a !== void 0 ? _a : container.retina.moveSpeed;
      var moveSpeed = baseSpeed / 2 * slowFactor * delta.factor;
      this.applyNoise(delta);
      particle.position.x += particle.velocity.horizontal * moveSpeed;
      particle.position.y += particle.velocity.vertical * moveSpeed;

      if (particlesOptions.move.vibrate) {
        particle.position.x += Math.sin(particle.position.x * Math.cos(particle.position.y));
        particle.position.y += Math.cos(particle.position.y * Math.sin(particle.position.x));
      }
    }
  }, {
    key: "applyNoise",
    value: function applyNoise(delta) {
      var particle = this.particle;
      var particlesOptions = particle.particlesOptions;
      var noiseOptions = particlesOptions.move.noise;
      var noiseEnabled = noiseOptions.enable;

      if (!noiseEnabled) {
        return;
      }

      var container = this.container;

      if (particle.lastNoiseTime <= particle.noiseDelay) {
        particle.lastNoiseTime += delta.value;
        return;
      }

      var noise = container.noise.generate(particle);
      particle.velocity.horizontal += Math.cos(noise.angle) * noise.length;
      particle.velocity.horizontal = Utils_1.Utils.clamp(particle.velocity.horizontal, -1, 1);
      particle.velocity.vertical += Math.sin(noise.angle) * noise.length;
      particle.velocity.vertical = Utils_1.Utils.clamp(particle.velocity.vertical, -1, 1);
      particle.lastNoiseTime -= particle.noiseDelay;
    }
  }, {
    key: "moveParallax",
    value: function moveParallax() {
      var container = this.container;
      var options = container.options;

      if (!options.interactivity.events.onHover.parallax.enable) {
        return;
      }

      var particle = this.particle;
      var parallaxForce = options.interactivity.events.onHover.parallax.force;
      var mousePos = container.interactivity.mouse.position;

      if (!mousePos) {
        return;
      }

      var windowDimension = {
        height: window.innerHeight / 2,
        width: window.innerWidth / 2
      };
      var parallaxSmooth = options.interactivity.events.onHover.parallax.smooth;
      var tmp = {
        x: (mousePos.x - windowDimension.width) * (particle.size.value / parallaxForce),
        y: (mousePos.y - windowDimension.height) * (particle.size.value / parallaxForce)
      };
      particle.offset.x += (tmp.x - particle.offset.x) / parallaxSmooth;
      particle.offset.y += (tmp.y - particle.offset.y) / parallaxSmooth;
    }
  }, {
    key: "getProximitySpeedFactor",
    value: function getProximitySpeedFactor() {
      var container = this.container;
      var options = container.options;
      var active = Utils_1.Utils.isInArray(Enums_1.HoverMode.slow, options.interactivity.events.onHover.mode);

      if (!active) {
        return 1;
      }

      var mousePos = this.container.interactivity.mouse.position;

      if (!mousePos) {
        return 1;
      }

      var particlePos = this.particle.getPosition();
      var dist = Utils_1.Utils.getDistance(mousePos, particlePos);
      var radius = container.retina.slowModeRadius;

      if (dist > radius) {
        return 1;
      }

      var proximityFactor = dist / radius || 0;
      var slowFactor = options.interactivity.modes.slow.factor;
      return proximityFactor / slowFactor;
    }
  }]);

  return Mover;
}();

exports.Mover = Mover;